<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getWorkOrderProcesss"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-work-order-process-number" label-cols-sm="4" label-cols-lg="3" label="Work Order Process Number" label-for="filter-work-order-process-number" size="sm" :model.sync="filter.workOrderProcessNumber" />
						<app-input-datepicker-range  id="fieldset-production-date" label-cols-sm="4" label-cols-lg="3" label="Production Date" size="sm" :modelFrom.sync="filter.productionDateFrom" :modelTo.sync="filter.productionDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
						<app-input-combobox-autocomplete :options="lines" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Line Code" id="filter-" size="sm" :model.sync="filter.lineCodeId" @input="getLines" @focus="getLines" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="processTypes" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Process Type" id="filter-" size="sm" :model.sync="filter.processTypeId" @input="getProcessTypes" @focus="getProcessTypes" />
					<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Document Status" id="filter-" size="sm" :model.sync="filter.documentStatusIdSelected" @input="getDocumentStatuss" @focus="getDocumentStatuss" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getWorkOrderProcesss"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Work Order Process</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm" v-if="false">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/workorderprocess/WorkOrderProcess.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="false" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="false"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button v-if="false" class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="false"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button v-if="false" class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button v-if="false" class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="isShowDeleteButton && !isdisabledFeatures"		
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-workorderprocess" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="workOrderProcesss" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="workOrderProcesss.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="Work Order Process Number" class="table-filter">
					<b-form-input id="input-work-order-process-number-table" @input="getWorkOrderProcesssWithoutLoading" v-model="filter.workOrderProcessNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Production Date" class="table-filter">
					<b-form-datepicker boundary="viewport" placeholder="" id="input-production-date-from-table" reset-button @input="getWorkOrderProcesssWithoutLoading" v-model="filter.productionDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
					<b-form-datepicker boundary="viewport" placeholder="" id="input-production-date-to-table" reset-button @input="getWorkOrderProcesssWithoutLoading" v-model="filter.productionDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
				</b-th>
				<b-th stacked-heading="Line Code" class="table-filter">
					<v-select append-to-body label="code" :options="lines" :value="filter.lineCodeId" :reduce="item => item.id" v-model="filter.lineCodeId" :filterable="true" @input="getWorkOrderProcesssWithoutLoading" @search="getLines"></v-select>
				</b-th>
				<b-th stacked-heading="Process Type" class="table-filter">
					<v-select append-to-body label="code" :options="processTypes" :value="filter.processTypeId" :reduce="item => item.id" v-model="filter.processTypeId" :filterable="true" @input="getWorkOrderProcesssWithoutLoading" @search="getProcessTypes"></v-select>
				</b-th>
				<!-- <b-th stacked-heading="Process Type" class="table-filter">
				</b-th> -->
				<b-th stacked-heading="Document Status" class="table-filter">
					<v-select append-to-body label="name" :options="documentStatuss" :value="filter.documentStatusIdSelected" :reduce="item => item.id" v-model="filter.documentStatusIdSelected" :filterable="true" @input="getWorkOrderProcesssWithoutLoading" @search="getDocumentStatuss"></v-select>
				</b-th>

						<!-- <b-th stacked-heading="Select All"> -->
							<!-- <b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox> -->
						<!-- </b-th> -->
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(workorderprocessnumber)="row">
						<a @click="() => ( $router.push({ name: 'workorderprocessdetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.workOrderProcessNumber != null && row.item.workOrderProcessNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.workOrderProcessNumber.slice(0, 30) + (row.item.workOrderProcessNumber.length > 30 ? "..." : "" ) : row.item.workOrderProcessNumber : "" }}
						</a>
					</template>

			<template v-slot:cell(productionDate)="row">
				{{ row.item.productionDate | moment("DD-MMM-YYYY") }}
			</template>
			<template v-slot:cell(lineCode)="row">
				{{ row.item.lineCode != null ? row.item.lineCode.code : "" }}
			</template>
			<template v-slot:cell(processType)="row">
				{{ row.item.processType != null ? row.item.processType.code : "" }}
			</template>
			<template v-slot:cell(processTypeName)="row">
				{{ row.item.processType != null ? row.item.processType.name : "" }}
			</template>
			<template v-slot:cell(documentStatus)="row">
				<div class="two-item">
					<span>{{ row.item.documentStatus != null ? row.item.documentStatus.name : "" }} </span>
					<span :class="getRectangleClass(row.item.documentStatusId)">&nbsp;</span>
				</div>
			</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<!-- <b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox> -->
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.lineCodeId" label="Line Code" :selected="row.item.lineCode != null ? row.item.lineCode.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.processTypeId" label="Process Type" :selected="row.item.processType != null ? row.item.processType.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-label label-cols-lg="12" size="sm" label="Process Type" :model="(model.processType != null) ? model.processType.name : null"  />
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.documentStatusId" label="Document Status" :selected="row.item.documentStatus != null ? row.item.documentStatus.name : ''" :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(workOrderProcesssPaging != null ? workOrderProcesssPaging.dataCount : 0)"
									:per-page="(workOrderProcesssPaging != null ? workOrderProcesssPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
        <PopupDataEditNotification entityName="approvalconfiguration"
            :dataId="currentDataId"
            @resetModalMethod="resetModal"
            label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    ::v-deep #table-list-workorderprocess.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-workorderprocess.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-workorderprocess.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
	.two-item {
		display: flex;
		padding: 10px;
		justify-content: space-between;
		align-items: center;
	}
	.rectangle {
		width: 30px;
		height: 30px;
	}
	.rectangle-danger {
		background-color: #DC3545;
	}
	.rectangle-warning {
		background-color: #FFC107;
	}
	.rectangle-success {
		background-color: #28A745;
	}
</style>
<script>
import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import WorkOrderProcessList from '@/models/WorkOrderProcess/WorkOrderProcessList';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';
import RoleDetail from '@/models/Core/RoleDetail';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import LineFilter from '@/filters/Line/LineFilter';
import Line from '@/models/Line/Line';
import ProcessTypeFilter from '@/filters/ProcessType/ProcessTypeFilter';
import ProcessType from '@/models/ProcessType/ProcessType';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import BillOfProcessFilter from '@/filters/BillOfProcess/BillOfProcessFilter';
import BillOfProcess from '@/models/BillOfProcess/BillOfProcess';
import MachineFilter from '@/filters/Machine/MachineFilter';
import Machine from '@/models/Machine/Machine';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		WorkOrderProcess, 
		WorkOrderProcessList, 
		WorkOrderProcessFilter, 
		AppInputTextbox,
		AppLabel,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"workOrderProcessNumber": {}, "class" : "th-work-order-process-number first-child", "label" : "Work Order Process Number", key: 'workOrderProcessNumber', sortable: true}, 
				{"productionDate": {}, "class" : "th-production-date", "label" : "Production Date", key: 'productionDate', sortable: true}, 
				{"lineCode": {}, "class" : "th-line-code last-child", "label" : "Line Code", key: 'lineCode', sortable: true}, 
				{"processType": {}, "class" : "th-process-type d-stack-none", "label" : "Process Type", key: 'processType', sortable: true}, 
				// {"processTypeName": {}, "class" : "th-process-type-name d-stack-none", "label" : "Process Type", key: 'processTypeName', sortable: true}, 
				{"documentStatus": {}, "class" : "th-document-status d-stack-none", "label" : "Document Status", key: 'documentStatus', sortable: true}, 
				{"remarks": {}, "class": "th-remarks d-stack-none", "label": "Remarks", key: "remarks", sortable: true},
				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isdisabledFeatures: true,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			workOrderProcesss: [],
			workOrderProcesssPaging: {},
			lines : [],
			processTypes : [],
			documentStatuss : [],
			workOrderProcessDetails : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
		}
	},	methods : {
		getRectangleClass(documentStatus) {
			console.log("documentStatus", documentStatus);
			let cls = "rectangle";
			if(documentStatus == "CLOSED") {
				cls += " rectangle-success";
			} else if(documentStatus == "IN_PROGRESS" || documentStatus == "IN_PROGRESS_PRODUCTION" || documentStatus == "IN_PROGRESS_RFP") {
				cls += " rectangle-warning";
			} else {
				cls += " rectangle-danger";
			}

			console.log("class", cls);
			return cls;
		}, 
		getWorkOrderProcesss : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			if(this.filter.documentStatusIdSelected) {
				this.filter.documentStatusId = this.filter.documentStatusIdSelected;
			}

			WorkOrderProcess.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.workOrderProcesss = result.data
					this.workOrderProcesssPaging = result
					this.filter.documentStatusId = null;
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getWorkOrderProcesssWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			if(this.filter.documentStatusIdSelected) {
				this.filter.documentStatusId = this.filter.documentStatusIdSelected;
			}

			WorkOrderProcess.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.workOrderProcesss = result.data
					this.workOrderProcesssPaging = result
					this.filter.documentStatusId = null;
				}
			})
			.catch(error => {});
		},
		getLines : async function(input) {
			let filter = new LineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Line.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.lines = result.data
				}
			})
			.catch(error => {});
		},
		getProcessTypes : async function(input) {
			let filter = new ProcessTypeFilter();
			if (input != undefined) {
				filter.code = input;
			}
			ProcessType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.processTypes = result.data
				}
			})
			.catch(error => {});
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new WorkOrderProcessFilter();
			this.filter.documentStatusId = "OPEN,IN_PROGRESS,IN_PROGRESS_PRODUCTION,IN_PROGRESS_RFP,CLOSED";
			this.getWorkOrderProcesss();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getWorkOrderProcesss();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				WorkOrderProcess.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			WorkOrderProcess.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			WorkOrderProcess.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			WorkOrderProcess.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'workorderprocessedit';
						if(this.isScannerMode) {
							createRoute = 'workorderprocessscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			WorkOrderProcess.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'workorderprocessedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			WorkOrderProcess.deleteData(this, id).then(result => {
				if (result)
				{
					this.getWorkOrderProcesss();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				WorkOrderProcess.deleteMultipleData(this).then(result => {
					this.getWorkOrderProcesss();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableWorkOrderProcessParent = document.getElementById('table-list-workorderprocess').parentNode;
			tableWorkOrderProcessParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableWorkOrderProcessParent.scrollWidth - tableWorkOrderProcessParent.offsetWidth) == Math.ceil(tableWorkOrderProcessParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableWorkOrderProcessParent = document.getElementById('table-list-workorderprocess').parentNode;
			tableWorkOrderProcessParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableWorkOrderProcessParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new WorkOrderProcessFilter();
		this.filter.documentStatusId = "OPEN,IN_PROGRESS,IN_PROGRESS_PRODUCTION,IN_PROGRESS_RFP,CLOSED";
		this.getLines()
		this.getProcessTypes()
		this.getDocumentStatuss()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Work Order Process"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		let currentDate = new Date();
		currentDate.setDate(currentDate.getDate() - parseInt(7));
		this.filter.productionDateFrom = currentDate.getFullYear() + '-' + (currentDate.getMonth() + 1) + '-' + currentDate.getDate();
		this.$nextTick(() => {
			this.getWorkOrderProcesss();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getWorkOrderProcesss();
			}
		},
		sortDesc: {
			handler: function() {
				this.getWorkOrderProcesss();
			}
		},
		currentPage: {
			handler: function() {
				this.getWorkOrderProcesss();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getWorkOrderProcesss();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				WorkOrderProcess.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "workorderprocessindex") {
					this.getWorkOrderProcesssWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "work_order_process").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
